"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const fastcheckoutbrand03 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 68",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-fastcheckoutbrand03` : '') + (description ? ` desc-fastcheckoutbrand03` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-fastcheckoutbrand03"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-fastcheckoutbrand03"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.841 5H4.174a2 2 0 0 0-2 2v29.333l.019.272a1.999 1.999 0 0 0 1.98 1.728h7.743l.001 27.334c0 1.968 2.545 2.752 3.653 1.125l24.924-36.586.141-.24c.649-1.294-.281-2.886-1.794-2.886l-9.037-.002L40.583 7.983C41.335 6.65 40.372 5 38.841 5Z",
    fill: "#FFB499",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "a",
    style: {
      "maskType": "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: "2",
    y: "5",
    width: "39",
    height: "63"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.175 5h38.67v62.67H2.175V5Z",
    fill: "#FFC599",
    fillOpacity: ".5"
  })), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1a1 1 0 0 1 1-1h36.174a1 1 0 0 1 .88 1.475L25.846 24.087h11.328a1 1 0 0 1 .838 1.546L12.004 65.546A1 1 0 0 1 10.166 65V34H1a1 1 0 0 1-1-1V1Zm2 1v30h9.166a1 1 0 0 1 1 1v28.634l23.163-35.547h-11.16a1 1 0 0 1-.88-1.476L35.499 2H2Z",
    fill: "#F04C24"
  }));
};
var _default = exports.default = fastcheckoutbrand03;